import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { getCases } from '../../../actions/case-actions';
import { formatDate } from '../../../actions/global-actions';
import { BsSearch, BsArrowUp, BsArrowDown } from "react-icons/bs";
import DatePicker from 'react-date-picker';
import Paginator from '../../../components/paginator/paginator';
import { commentsTableBody, commentsTableHeaders } from './comments-data';
import TableComponent from '../../../components/table/table';

function CasesWithComments(){
    const currentLink = "/casos/historial";
    const dispatch = useDispatch();
    const [cases, setCases] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [showContainer, setShowContainer] = useState(false);
    const [skip, setSkip] = useState(0);

    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    const [form, setForm] = useState({
        date: '',
        filingNumber: '',
        client: '',
        attorney: '',
    })

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log(data.data);
                if (data.data && data.data.length > 0) {
                    data.data.map( caseObj => {
                        let type = caseObj.caseType;
                        caseObj.caseType = type.charAt(0).toUpperCase() + type.slice(1);
                        caseObj.formattedDate = formatDate(caseObj.date, 4);
                        caseObj.attorneyText = `${caseObj.attorneyInCharge.userId.firstName} ${caseObj.attorneyInCharge.userId.lastName}`;
                        caseObj.clientText = `${caseObj.client.clientId.firstName} ${caseObj.client.clientId.lastName}`;
                        caseObj.details = `${caseObj.case.position} No.${caseObj.autoOpening}`;
                        caseObj.commentsText = caseObj.comments.length || 0;
                        return caseObj;
                    });
                }
                setCases(data.data);

                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }

        if (loadData) {
            setLoadData(false);
            setCases([]);
            let params = form;
            params = {
                ...params,
                query: { "comments.0" : { "$exists" : true } }
            }
            dispatch( getCases( params, skip, getFunction, user.token ) );
        }
    }, [loadData, dispatch, user.token, form, skip, paginatorData]);

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] !== '' && form[field] ) {
                    return false
                }
            }
        }
        return true
    }

    const searchFunction = () => {
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar algún campo para continuar",
            });
            return;
        } else {
            stockPaginator();
            setLoadData(true);
        }
    }

    const toggleContainer = () => {
        setShowContainer(!showContainer)
    }
    
    const handleDateChange = ( name, date ) => {
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    const deleteSearch = () => {
        setForm({
            date: '',
            filingNumber: '',
            client: '',
            attorney: '',
        })
        stockPaginator();
        setLoadData(true);
    }

    useEffect(() => {
        //console.log(form);
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Historial de seguimiento a casos</h1>
                <div className="d-flex flex-column w-100">
                    <div onClick={toggleContainer} style={{ width: 'fit-content', cursor: 'pointer'}}>
                        <h4 className="w-100 my-2 d-flex"> Búsqueda
                            {showContainer?
                                <BsArrowUp className="arrow-icon"/>
                            :
                                <BsArrowDown className="arrow-icon"/>
                            }
                        </h4>
                    </div>
                    {showContainer &&
                        <div className="w-100 d-flex"> 
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field">Fecha</label>
                                <DatePicker
                                    value={ form.date }
                                    dayAriaLabel={"Día"}
                                    dayPlaceholder={"dd"}
                                    monthAriaLabel={"Mes"}
                                    monthPlaceholder={"mm"}
                                    yearAriaLabel={"Año"}
                                    yearPlaceholder={"yyyy"}
                                    name={"date"}
                                    onChange={ (date)=>handleDateChange( 'date', date ) }
                                    dateFormat="MM/dd/yyyy"
                                />
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="filingNumber">Radicado</label>
                                <input type="text" className="input-field" id="filingNumber" name="filingNumber" autoComplete="off" placeholder="No de radicado" onChange={handleInputChange} value={form.filingNumber}></input>
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="client">Cliente</label>
                                <input type="text" className="input-field" id="client" name="client" autoComplete="off" placeholder="Nombre, apellido o documento" onChange={handleInputChange} value={form.client}></input>
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="attorney">Abogado</label>
                                <input type="text" className="input-field" id="attorney" name="attorney" autoComplete="off" placeholder="Nombre, apellido o documento" onChange={handleInputChange} value={form.attorney}></input>
                            </div>
                            <div className="d-flex search-button m-2 justify-content-center align-items-center" onClick={searchFunction}>
                                <BsSearch/>
                            </div>
                        </div>
                    }
                    {showContainer &&
                        <div className="w-100 d-flex justify-content-center my-1">
                            <span className="delete-search-text" onClick={deleteSearch}>
                                Eliminar búsqueda
                            </span>
                        </div>
                    }
                </div>
                <div className="w-100 d-flex justify-content-between mt-3 mb-1">
                    <span className='align-self-center'>Casos: <b>{paginatorData.totalitems}</b></span>
                </div>
                <TableComponent
                    id={"comments-table"}
                    headers={commentsTableHeaders}
                    body={commentsTableBody}
                    skip={skip}
                    data={cases}
                    link={`${currentLink}/`}
                    />
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0? 
                    <Paginator skip={skip} data={paginatorData} setSkip={(n) => setSkip(n)} setLoadData={(need) => setLoadData(need)} />
                :
                    null
                }
            </div>
        </div>
    );
}

export default CasesWithComments;
  